export default {
    dependencies: ['$element', 'reportReviewService'],
    callable(element, reportReviewService) {
        const reviewIdElement = element.querySelector('[name=reviewId]');
        const complaintInputElement = element.querySelector(
            '[name=complaintReason]'
        );
        const submitElement = element.querySelector('input[type=submit]');
        const characterCountElement = element.querySelector(
            '[data-character-count]'
        );
        const errorMessageElement = element.querySelector(
            '[data-report-review-error-message]'
        );
        const successMessageElement = element.querySelector(
            '[data-report-review-success-message]'
        );

        const maxCharacterCount = characterCountElement.getAttribute(
            'data-max-character-count'
        );

        complaintInputElement.addEventListener('keyup', updateCharacterCount);
        complaintInputElement.addEventListener(
            'keyup',
            handleEnableReportButton
        );
        element.addEventListener('submit', handleFormSubmit);

        updateCharacterCount();

        function updateCharacterCount() {
            const charsLeft = maxCharacterCount - getInputLength();
            let text;
            if (charsLeft >= 0) {
                text = `${charsLeft} tegn gjenstår`;
            } else {
                text = `${Math.abs(charsLeft)} tegn over`;
            }
            characterCountElement.textContent = text;
        }

        function handleEnableReportButton() {
            submitElement.disabled = getInputLength() === 0;
        }

        function handleFormSubmit(e) {
            handlePostReviewComplaint();
            e.preventDefault();
            return false;
        }

        function handlePostReviewComplaint() {
            disableInputs();
            reportReviewService
                .postReviewComplaint(
                    reviewIdElement.value,
                    complaintInputElement.value
                )
                .then(displaySuccessMessage)
                .catch(displayErrorMessage);
        }

        function displayErrorMessage(xhr) {
            enableInputs();
            const errorMessage =
                xhr.responseText || 'Det oppsto en feil - prøv igjen';
            errorMessageElement.textContent = errorMessage;
        }

        function displaySuccessMessage() {
            errorMessageElement.parentElement.removeChild(errorMessageElement);
            successMessageElement.classList.remove('hidden');
            successMessageElement.removeAttribute('aria-hidden');
        }

        function disableInputs() {
            complaintInputElement.disabled = true;
            submitElement.disabled = true;
        }

        function enableInputs() {
            complaintInputElement.disabled = false;
            submitElement.disabled = false;
        }

        function getInputLength() {
            return complaintInputElement.value.length || 0;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/reportReview.js